import Theme from 'Theme';
import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';

const baseStyles = {
    titleContainer: {
        flexDirection: 'column'
    },
    iconsContainer: {
        flexDirection: 'row',
        marginVertical: 8
    },
    title: {
        fontFamily: Theme.regularFont,
        fontSize: Theme.fontSizes.title,
        color: Theme.primaryTextColor,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch'
    },
    recordingStateIcon: {
        width: 20,
        height: 20,
        marginTop: 3,
        marginRight: 10
    },
    subtitle: {
        fontFamily: Theme.regularFont,
        fontSize: Theme.fontSizes.subtitle,
        color: Theme.secondaryTextColor,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        marginTop: 6,
        letterSpacing: 0.7
    },
    channelIcon: {
        width: Theme.BU * 2.4,
        height: Theme.BU * 2.4
    },
    line: {
        backgroundColor: Theme.primaryTextColor,
        height: 1.8,
        width: '5%',
        marginTop: '3%',
        marginBottom: '2%'
    },
    description: {
        fontFamily: Theme.regularFont,
        fontSize: Theme.fontSizes.description,
        color: Theme.primaryTextColor,
        paddingTop: 20,
        paddingBottom: 20
    },
    bottomDivider: {
        marginBottom: 20
    },
    ratingContainer: {
        marginTop: 8,
        marginBottom: Device.isWeb ? 25 : 0
    },
    buttonsContainer: {
        marginVertical: 0,
        height: 'auto'
    },
    hrMargin: {
        marginTop: 25
    }
};

export const webDescription = {
    fontFamily: Theme.regularFont,
    fontSize: Theme.fontSizes.description,
    color: Theme.primaryTextColor,
    paddingTop: 20,
    paddingBottom: 20
};

const playerInfoStyles = StyleSheet.create({
    title: {
        fontSize: Theme.fontSizes.title
    },
    subTitle: {
        fontSize: Theme.fontSizes.subtitle,
        paddingBottom: 20
    },
    description: {
        fontFamily: Theme.regularFont,
        fontSize: Theme.fontSizes.description,
        color: Theme.primaryTextColor,
        paddingBottom: 20
    },
    bottomDivider: {
        paddingBottom: 0
    }
});

export { playerInfoStyles };

const detailPreviewStyles = StyleSheet.create({
    title: {
        fontSize: Theme.fontSizes.title
    },
    subTitle: {
        fontSize: Theme.fontSizes.subtitle
    }
});

export { detailPreviewStyles };

const detailsPopupStyles = StyleSheet.create({
    channelIcon: {
        marginTop: 40,
        width: Theme.BU * 3,
        height: Theme.BU * 3
    }
});

export { detailsPopupStyles };

export default StyleSheet.create(baseStyles);
